import {
    GET_LIST_BLOOD_GROUP,
    GET_SPECIFIC_BLOOD_GROUP,
    UPDATE_SPECIFIC_BLOOD_GROUP,
    CREATE_NEW_BLOOD_GROUP,
    REMOVE_BLOOD_GROUP,
    GET_BLOOD_GROUP_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    blood_group_list: [],
    currentBlood_group_list: null,
    blood_group_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_BLOOD_GROUP: {
            return {
                ...state,
                blood_group_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_BLOOD_GROUP_ACTIVE: {
            return {
                ...state,
                blood_group_active_list: action.payload?.data || [],
            }
        }
        case GET_SPECIFIC_BLOOD_GROUP: {
            return { ...state, currentBlood_group_list: action.payload }
        }
        case CREATE_NEW_BLOOD_GROUP: {
            return {
                ...state,
                blood_group_list: [action.payload, ...state.blood_group_list],
                blood_group_active_list: [action.payload, ...state.blood_group_active_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_BLOOD_GROUP: {
            let index = state.blood_group_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.blood_group_list];
            temp[index] = action.payload;
            //
            let index2 = state.blood_group_active_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.blood_group_active_list];
            temp[index2] = action.payload;

            return { ...state, blood_group_list: temp, blood_group_active_list: temp2 }
        }
        case REMOVE_BLOOD_GROUP: {
            let temp = state.blood_group_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.blood_group_active_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, blood_group_list: temp, blood_group_active_list: temp2 }
        }
        default: return { ...state };
    }
}
